//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
export default {
  data() {
    return {
      timeoutId: false,
    };
  },
  computed: {
    ...mapState({
      alert: ({ alertStore: { alert } }) => alert,
      modal: ({ modalStore: { modal } }) => modal,
    }),
  },
  mounted: function () {
    if (!this.timeoutId) {
      this.timeoutAlert();
    }
  },
  watch: {
    'alert.active': function (newVal, oldVal) {
      if (newVal) {
        this.timeoutAlert();
      }
    },
  },
  methods: {
    timeoutAlert() {
      let timeout = 5000;
      if (this.alert.timeout) {
        timeout = this.alert.timeout;
      }
      this.timeoutId = setTimeout(() => {
        this.$store.commit('alertStore/clearAlert');
        this.$forceUpdate();
      }, timeout);
    },
  },
};
